import { useContext } from 'react'
import { uniqueId } from 'lodash-es'

import { AsyncTasks } from '../../context'

export function useAsyncTask() {
  const { addAsyncTask, asyncTasks, removeAsyncTask } = useContext(AsyncTasks)

  function handleAddAsyncTask(task) {
    addAsyncTask({
      ...task,
      id: task.id || `async-task-${uniqueId()}`,
    })
  }

  function handleRemoveAsyncTask(id) {
    removeAsyncTask(id)
  }

  return { asyncTasks, handleAddAsyncTask, handleRemoveAsyncTask }
}
